module.exports = __webpack_public_path__ + "img/4-4-marquee-2.f4dda384.jpg";